module.exports = __webpack_public_path__ + "static/media/receta-20.9576263b.png";